import { Event } from '../types/supabase';
import { toICSRule } from '../lib/recurrence';

export const formatDateDisplay = (dateString: string): string => {
  const [year, month, day] = dateString.split('-');
  const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
  return date.toLocaleDateString();
};

export const getTimezoneAbbreviation = (timezone: string): string => {
  const timezoneMap: Record<string, string> = {
    'America/New_York': 'ET',
    'America/Chicago': 'CT',
    'America/Denver': 'MT',
    'America/Los_Angeles': 'PT',
    'America/Anchorage': 'AKT',
    'Pacific/Honolulu': 'HT',
  };
  return timezoneMap[timezone] || timezone;
};

export const generateICSContent = (event: Event): string => {
  const [year, month, day] = event.date.split('-');
  const [hours, minutes] = event.time.split(':');

  const pad = (num: number): string => num.toString().padStart(2, '0');

  const startDateTime = `${year}${pad(parseInt(month))}${pad(parseInt(day))}T${pad(parseInt(hours))}${pad(parseInt(minutes))}00`;

  const endHour = (parseInt(hours) + 2) % 24;
  const endDateTime = `${year}${pad(parseInt(month))}${pad(parseInt(day))}T${pad(endHour)}${pad(parseInt(minutes))}00`;

  const recurrenceRule = toICSRule(event);

  const icsContent = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Monday Night Group//Events//EN',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'BEGIN:VEVENT',
    `UID:${event.id}@mondaynightgroup.com`,
    `SUMMARY:${event.title}`,
    `DESCRIPTION:${event.description}`,
    `LOCATION:${event.location}`,
    `DTSTART;TZID=${event.timezone}:${startDateTime}`,
    `DTEND;TZID=${event.timezone}:${endDateTime}`,
    ...(recurrenceRule ? [recurrenceRule] : []),
    'BEGIN:VALARM',
    'TRIGGER:-PT30M',
    'ACTION:DISPLAY',
    'DESCRIPTION:Reminder',
    'END:VALARM',
    'END:VEVENT',
    'END:VCALENDAR',
  ].join('\r\n');

  return icsContent;
};

export const downloadICSFile = (event: Event): void => {
  const icsContent = generateICSContent(event);
  const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = `${event.title.toLowerCase().replace(/\s+/g, '-')}.ics`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};